import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { ButtonLink } from '../ui/ButtonLink';
import { discussSearchHref, primaryNav } from '../../data/navigation';
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-navy" data-id="element-233" data-mp="6voo9y6yf55e">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-6 px-5 sm:px-8" data-id="element-234" data-mp="6tklxkopee78">
        <Link to="/" aria-label="Avenqor Talent Search — Home" className="shrink-0" data-id="element-235" data-mp="bsouqa7pu9x1">
          <Logo tone="light" data-id="element-236" data-mp="gm016a8m8oof" />
        </Link>

        <nav aria-label="Primary" className="hidden xl:block" data-id="element-237" data-mp="lkbcyqih199a">
          <ul className="flex items-center gap-5 2xl:gap-8" data-id="element-238" data-mp="lmnskx0rb7j6">
            {primaryNav.map(item => <li key={item.to} data-id="element-239" data-mp="3k4bbh6gbdz16">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `group relative block whitespace-nowrap py-2 text-[13px] transition-colors duration-200 ease-out 2xl:text-[14px] ${isActive ? 'text-white' : 'text-white/70 hover:text-white focus-visible:text-white'}`} data-id="element-240" data-mp="3p0rw3qob1v9i">
                  {({
                isActive
              }) => <>
                      {item.label}
                      <span aria-hidden="true" className={`absolute inset-x-0 -bottom-px h-px origin-left bg-gold transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100 group-focus-visible:scale-x-100'}`} data-id="element-241" data-mp="3aak17nuisxk0" />
                    </>}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-3" data-id="element-242" data-mp="30e7amyu9uzth">
          <ButtonLink to={discussSearchHref} variant="gold" className="hidden h-11 px-5 text-sm sm:inline-flex" data-id="element-243" data-mp="30ez526c4uri6">
            Discuss a Search
          </ButtonLink>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-menu" aria-label={open ? 'Close menu' : 'Open menu'} className="flex h-11 w-11 items-center justify-center rounded-sm border border-white/20 text-white transition-colors duration-150 ease-out hover:border-gold xl:hidden" data-id="element-244" data-mp="27xeed8to3x1r">
            {open ? <XIcon className="h-5 w-5" data-id="element-245" data-mp="9h5jkil8koo9" /> : <MenuIcon className="h-5 w-5" data-id="element-246" data-mp="9hxd7nv9wcbw" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-247" data-mp="efpakxeosqnh">
        {open && <motion.div id="mobile-menu" initial={reduceMotion ? false : {
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-x-0 bottom-0 top-20 overflow-y-auto border-t border-white/10 bg-navy xl:hidden" data-id="element-248" data-mp="1251f3jz2kajg">
            <nav aria-label="Mobile" className="mx-auto max-w-7xl px-5 py-8 sm:px-8" data-id="element-249" data-mp="3cvrqqtxs0swj">
              <ul data-id="element-250" data-mp="3hw61ijqrigy9">
                {primaryNav.map(item => <li key={item.to} className="border-b border-white/10" data-id="element-251" data-mp="1055lddvm5kj">
                    <NavLink to={item.to} end={item.to === '/'} className={({
                isActive
              }) => `flex items-center justify-between py-4 font-serif text-[1.65rem] font-medium ${isActive ? 'text-gold' : 'text-white'}`} data-id="element-252" data-mp="11gcvn6j5vge">
                      {item.label}
                    </NavLink>
                  </li>)}
              </ul>
              <ButtonLink to={discussSearchHref} variant="gold" className="mt-8 w-full" data-id="element-253" data-mp="aycldswfihky">
                Discuss a Search
              </ButtonLink>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}